import { IGlobalState } from '../../../Root/store/appReducer'

export const getFeatures = (state: IGlobalState) => state.featuresAdmin?.features
export const getFeaturesLoading = (state: IGlobalState) => state.featuresAdmin?.loading
export const getFeaturesSaving = (state: IGlobalState) => state.featuresAdmin?.saving
